import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({
  title,
  description,
  canonical,
  image = 'https://www.vekianlabs.com/images/social-share.webp',
  type = 'website',
  keywords = 'Vekian Labs, análisis de datos, business intelligence, BI, desarrollo de software, desarrollo full stack, cloud solutions, frontend, innovación, consultoría tecnológica, Ecuador'
}) {
  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonical}#webpage`,
    url: canonical,
    name: title,
    description,
    inLanguage: 'es-EC',
    isPartOf: { '@id': 'https://www.vekianlabs.com/#website' },
    about: { '@id': 'https://www.vekianlabs.com/#organization' },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: image
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <link rel='canonical' href={canonical} />

      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content={type} />
      <meta property='og:url' content={canonical} />
      <meta property='og:image' content={image} />
      <meta property='og:site_name' content='Vekian Labs' />
      <meta property='og:locale' content='es_EC' />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={image} />
      <meta name='twitter:image:alt' content={title} />

      <script type='application/ld+json'>
        {JSON.stringify(pageSchema)}
      </script>
    </Helmet>
  );
}

export default SEO;
